import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import axios from '../../tools/axiosWrapper';

import "./join.css";

export const Join = () => {
    let [searchParams] = useSearchParams();
    
    const replyid = searchParams.get('a');
    const [isLoading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    async function fetchReply() {
        try {
            setLoading(true);
            await axios.post("/event/join_reply/", { replyid });
            setSuccess(true);
        } catch (error) {
            setSuccess(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchReply();
    }, []);

    let message = success ? <span>You have joined this event and will now receive event reminders.</span> : <span>Unfortunately, we cannot complete your request at this time.</span>;

    if (isLoading) {
        return (
            <main>
                <p>Loading...</p>
            </main>
        );
    }

    return (
        <main>
            {success && <h1>YOU'RE IN!</h1>}
            <p>{message}<br />Use the JoinU@Harvard app or visit <a href="app.joinu.org">app.joinu.org</a> for more information.</p>
        </main>
    );
};
